import ApiService from '../ApiService';
import axios from "axios";
import store from '../../store/index';
const accessToken = store.state.auth.token;

const DeliveryService = {

    async sendDelivery(data) {
        console.log("console---->", data)
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/scheduling`,
            data,
            method: 'POST',
            headers: {
                'x-request-public-key': process.env.VUE_APP_FARMADOMICILIOS_CLIENT_KEY,
                "Authorization": accessToken
            }
        });
    }
}

export default DeliveryService;